import { runInAction } from 'mobx'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

import commonRepo from '@/repository/common.repo'
import { commonWorkbookService } from '@/service/commonWorkbook.service'

export const useInspectWorkbooks = () => {
  const { search } = useLocation()

  useEffect(() => {
    if (search) {
      const device = new URLSearchParams(search).get('device') || ''
      const version = new URLSearchParams(search).get('version') || ''
      runInAction(() => {
        commonRepo.version = version
        commonRepo.device = device
      })
    }
    commonWorkbookService.fetchInspectBookCode()
  }, [])
}
